import config from './config.json'

//Set environment name
const environment = 'production';  
const whatsapNumber = 'post_venta'; 
const defaultConfig = config.development.post_venta;
const environmentConfig = config[environment][whatsapNumber];
const finalConfig = Object.assign(defaultConfig, environmentConfig);

// as a best practice
// all global variables should be referenced via global. syntax
// and their names should always begin with g
global.gConfig = finalConfig;
